import React, { Component } from 'react';
import { func, number, object, string } from 'prop-types';

import LoadingState from '../../../LoadingState';

import cx from 'classnames';
import s from './HealthRecordActions.css';


export default class HealthRecordActions extends Component {
  static propTypes = {
    id: number,
    format: string,
    handleTransmitForm: func,
    handleViewRecord: func,
    selectedHealthRecordListItem: object,
  };

  constructor(props) {
    super(props);

    this.state = {
      disabled: false,
    };
  }

  componentWillReceiveProps(nextProps) {
    const recordIsLoading = nextProps.selectedHealthRecordListItem.isLoading;
    const currentRecordId = nextProps.id;
    const clickedRecordId = nextProps.selectedHealthRecordListItem.recordId;

    // A record isLoading, disable all other buttons to prevent user from clicking and starting a new API request
    if (recordIsLoading && clickedRecordId !== currentRecordId) {
      this.setState({ disabled: true });
    } else {
      this.setState({ disabled: false });
    }
  }

  transmitForm = () => {
    const transmitData = {
      id: this.props.id,
      format: this.props.format,
    };

    this.props.handleTransmitForm(transmitData);
  };

  viewRecord = () => this.props.handleViewRecord(this.props.id);

  render = () => {
    const recordIsLoading = this.props.selectedHealthRecordListItem.recordId === this.props.id;

    return (
      <section className={s.component}>
        <a
          id={`downloadText_${this.props.id}`}
          download={this.props.id}
          href={`/api/records/download/html/${this.props.id}`}
          name="Save Information"
          className={s.cta}
          target="_blank"
          title="Save Information"
        >
          Save Information
        </a>
        <a
          id={`downloadData_${this.props.id}`}
          download={this.props.id}
          href={`/api/records/download/xml/${this.props.id}`}
          name="Save File"
          className={s.cta}
          target="_blank"
          title="Save File"
        >
          Save File
        </a>
        <button
          id={`transmit_${this.props.id}`}
          className={s.cta}
          onClick={this.transmitForm}
          title="Send Information"
        >
          Send Information
        </button>
        <button
          id={`viewRecord_${this.props.id}`}
          name="View Information"
          className={cx(s.cta, s.primary)}
          title="View Information"
          onClick={this.viewRecord}
          disabled={this.state.disabled || recordIsLoading}
        >
          {recordIsLoading ? (
            <LoadingState context="healthRecordActionsViewRecord" />
          ) : (
            'View Information'
          )}
        </button>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Pages/Health/HealthRecordActions/HealthRecordActions.js